export default __webpack_public_path__ + "static/media/step1.5be9988f.png";